// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quota-pricing[data-v-edd1f076] {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}
.quota-pricing .top[data-v-edd1f076],
.quota-pricing .bottom[data-v-edd1f076] {
  flex: 1;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/QuotaPricing.vue","webpack://./QuotaPricing.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;ACAF;ADPA;;EAUI,OAAA;EACA,WAAA;ACCJ","sourcesContent":["\n.quota-pricing {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  gap: 10px;\n  .top,\n  .bottom {\n    flex: 1;\n    width: 100%;\n  }\n}\n",".quota-pricing {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  gap: 10px;\n}\n.quota-pricing .top,\n.quota-pricing .bottom {\n  flex: 1;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
